import React from 'react';
import { Link } from 'react-router-dom';
import { insights } from '../mockData';
import { Calendar, User, Clock, FileText, Newspaper, Mic, Award } from 'lucide-react';

const Insights = () => {
  const getIcon = (type) => {
    switch (type) {
      case 'blog':
        return FileText;
      case 'whitepaper':
        return Award;
      case 'news':
        return Newspaper;
      case 'press-release':
        return Mic;
      case 'event':
        return Calendar;
      default:
        return FileText;
    }
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-indigo-600 via-purple-600 to-indigo-800 text-white py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">Insights & Resources</h1>
            <p className="text-xl text-indigo-100">
              Stay informed with the latest trends, best practices, and thought leadership from TECHSPR experts.
            </p>
          </div>
        </div>
      </section>

      {/* Insights Grid */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {insights.map((insight) => {
              const Icon = getIcon(insight.type);
              return (
                <Link
                  key={insight.id}
                  to={`/insights/${insight.id}`}
                  className="group bg-white rounded-2xl overflow-hidden border-2 border-gray-200 hover:border-indigo-500 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1"
                >
                  {/* Header with Type Badge */}
                  <div className="bg-gradient-to-br from-indigo-50 to-purple-50 p-6">
                    <div className="flex items-center space-x-2 mb-4">
                      <Icon className="w-5 h-5 text-indigo-600" />
                      <span className="text-sm font-semibold text-indigo-600 uppercase">
                        {insight.type.replace('-', ' ')}
                      </span>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 group-hover:text-indigo-600 transition-colors duration-200">
                      {insight.title}
                    </h3>
                  </div>

                  {/* Content */}
                  <div className="p-6">
                    <p className="text-gray-600 mb-4 line-clamp-3">{insight.excerpt}</p>

                    {/* Meta Information */}
                    <div className="space-y-2 text-sm text-gray-500">
                      <div className="flex items-center space-x-2">
                        <Calendar className="w-4 h-4" />
                        <span>{new Date(insight.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
                      </div>
                      {insight.author && (
                        <div className="flex items-center space-x-2">
                          <User className="w-4 h-4" />
                          <span>{insight.author}</span>
                        </div>
                      )}
                      {insight.readTime && (
                        <div className="flex items-center space-x-2">
                          <Clock className="w-4 h-4" />
                          <span>{insight.readTime}</span>
                        </div>
                      )}
                    </div>

                    {/* Category */}
                    <div className="mt-4">
                      <span className="inline-block px-3 py-1 bg-indigo-100 text-indigo-700 text-xs font-medium rounded-full">
                        {insight.category}
                      </span>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Insights;